import PropTypes from 'prop-types'
import React from 'react'

export const PhotoLimit = ({packages}) =>
  <tr>
    <td>Broj <strong>fotografija</strong> u galeriji</td>
    {
      packages.map(item => <td key={item.id}>{Number(item.photoLimit)}</td>)
    }
  </tr>

PhotoLimit.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    photoLimit: PropTypes.number
  })).isRequired
}

PhotoLimit.defaultProps = {
  packages: []
}
